import { getAuthToken } from "@jumbo/services/auth/jwtAuth";
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";

const AuthGuard = ({ children, redirectTo }) => {
  const { authUserData } = useSelector((state) => state.CommonReducer);
  const location = useLocation();
  //const auth = (getAuthToken() != null) ? true : null;
  const auth = localStorage.getItem("access_token") != null ? true : null;
  if (auth) {
    if (authUserData?.is_sys_admin == 0) {
      let isRedirect = false;
      const locPath = location.pathname;
      if (
        authUserData.user_assoc_profiles.includes("advertiser") == false &&
        (locPath == "/advertiser/manageadvertisers" ||
          locPath == "/advertiser/createadvertiser" ||
          locPath.startsWith("/advertiser/editadvertiser") ||
          locPath == "/targeting/campaigns" ||
          locPath == "/targeting/createcampaign" ||
          locPath.startsWith("/targeting/editcampaign") ||
          locPath == "/targeting/targetinggroups" ||
          locPath == "/targeting/createtgroup" ||
          locPath.startsWith("/targeting/edittgroup"))
      ) {
        isRedirect = true;
      } else if (
        (locPath == "/targeting/targetinggroups" ||
          locPath == "/targeting/createtgroup" ||
          locPath.startsWith("/targeting/edittgroup")) &&
        authUserData.user_permissions?.includes(
          "enable_target_groups_creation"
        ) == false
      ) {
        isRedirect = true;
      }

      if (
        authUserData.user_assoc_profiles.includes("bidder") == false &&
        (locPath == "/bidder/managedemandpartners" ||
          locPath == "/bidder/createdemandpartner" ||
          locPath.startsWith("/bidder/editdemandpartner") ||
          locPath == "/bidder/responsesample" ||
          locPath == "/bidder/manageprivatemarketplace" ||
          locPath == "/bidder/createprivatemarketplace" ||
          locPath.startsWith("/bidder/editprivatemarketplace"))
      ) {
        isRedirect = true;
      } else if (
        (locPath == "/bidder/manageprivatemarketplace" ||
          locPath == "/bidder/createprivatemarketplace" ||
          locPath.startsWith("/bidder/editprivatemarketplace")) &&
        authUserData.user_permissions?.includes("show_deals") == false
      ) {
        isRedirect = true;
      }

      if (
        authUserData.user_assoc_profiles.includes("publisher") == false &&
        (locPath == "/publisher/managepublishers" ||
          locPath == "/publisher/createpublisher" ||
          locPath.startsWith("/publisher/editpublisher") ||
          locPath == "/publisher/supplydeals" ||
          locPath == "/publisher/createsupplydeal" ||
          locPath.startsWith("/publisher/editsupplydeal") ||
          locPath == "/targeting/supplyanalysis" ||
          locPath == "/targeting/createsupplyanalysis" ||
          locPath.startsWith("/targeting/editsupplyanalysis") ||
          locPath == "/publisher/responsesample")
      ) {
        isRedirect = true;
      } else if (
        (locPath == "/advertiser/manageadvertisers" ||
          locPath == "/advertiser/createadvertiser" ||
          locPath.startsWith("/advertiser/editadvertiser")) &&
        authUserData?.is_adv_admin == 0
      ) {
        isRedirect = true;
      } else if (
        (locPath == "/publisher/managepublishers" ||
          locPath == "/publisher/createpublisher" ||
          locPath.startsWith("/publisher/editpublisher")) &&
        authUserData?.is_pub_admin == 0
      ) {
        isRedirect = true;
      } else if (
        (locPath == "/publisher/supplydeals" ||
          locPath == "/publisher/createsupplydeal" ||
          locPath.startsWith("/publisher/editsupplydeal")) &&
        authUserData.user_permissions?.includes(
          "enable_supply_dealids_creation"
        ) == false
      ) {
        isRedirect = true;
      } else if (
        locPath == "/publisher/responsesample" &&
        authUserData.user_permissions?.includes("show_request_samples") == false
      ) {
        isRedirect = true;
      } else if (
        (locPath == "/bidder/managedemandpartners" ||
          locPath == "/bidder/createdemandpartner" ||
          locPath.startsWith("/bidder/editdemandpartner")) &&
        authUserData?.is_bidder_admin == 0
      ) {
        isRedirect = true;
      } else if (
        locPath == "/bidder/responsesample" &&
        authUserData.user_permissions?.includes("show_request_samples") == false
      ) {
        isRedirect = true;
      }

      //Audience Management
      if (
        (locPath == "/audience/segments" ||
          locPath == "/targeting/createaudience" ||
          locPath.startsWith("/targeting/editaudiencesegment/")) &&
        authUserData.user_permissions?.includes("enable_location_segments") ==
          false
      ) {
        isRedirect = true;
      }

      // GeoIntel — requires role permission plus per-user enablement or sys_admin
      if (
        locPath == "/audience/geointel" &&
        authUserData.is_sys_admin != "1" &&
        (authUserData.user_permissions?.includes("enable_geointel") == false ||
          authUserData.geointel_enabled != "1")
      ) {
        isRedirect = true;
      }

      //Payments

      if (
        (locPath == "/payments/addpayment" &&
          authUserData.user_permissions?.includes("enable_make_payment") ==
            false) ||
        (locPath == "/payments/paymenthistory" &&
          authUserData.user_permissions?.includes("show_payment_history_tab") ==
            false)
      ) {
        isRedirect = true;
      }

      if (isRedirect) {
        return (
          <Navigate
            to={redirectTo ? redirectTo : "/home/reporting"}
            replace
            state={{ path: location.pathname }}
          />
        );
      }
    }

    return children;
  }
  return (
    <Navigate
      to={redirectTo ? redirectTo : "/login"}
      replace
      state={{ path: location.pathname }}
    />
  );
};

AuthGuard.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.shape({ render: PropTypes.func.isRequired }),
    PropTypes.func,
  ]),
};

export default AuthGuard;
